import { BaseService } from "./BaseService";

export class OrganizationsService extends BaseService {

    constructor(url) {
        
        super(url);
    }

    async getDataOrganizations(params) {
        return this.get(params)
    }

    async getDetailsOrganization(params) {
        return this.get(params)
    }

    async createOrganization(params){
        return this.create(params)
    }

    async updateOrganization(params){
        return this.update(params)
    }

    async deleteOrganization(params) {
        return this.delete(params)
    }

    async getDetailsUser(params) {
        return this.get(params)
    }

    async createUser(params){
        return this.create(params)
    }

    async updateUser(params){
        return this.update(params)
    }

    async blockUser(params){
        return this.update(params)
    }

    async deleteUser(params){
        return this.delete(params)
    }
}